import { monthOptions, yearOptions } from '@/components/attachment-uploader/utils'
import {
  Popover,
  PopoverHandler,
  PopoverContent,
  Button,
  Typography
} from '@material-tailwind/react'
import { useEffect, useState } from 'react'
import { FiCalendar } from 'react-icons/fi'
import { useSearchParams } from 'react-router-dom'
import Select from 'react-select'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

export const PeriodFilter = () => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [period, setPeriod] = useState({ month: null, year: null })

  const onChangePeriodYear = ({ value }) => setPeriod({ ...period, year: value })
  const onChangePeriodMonth = ({ value }) => setPeriod({ ...period, month: value })

  useEffect(() => {
    if (period.year && period.month) {
      const currentPeriod = moment([period.month, 1, period.year].join('-')).format('DD-MM-YYYY')
      searchParams.set('period', currentPeriod)
      setSearchParams(searchParams)
    }
  }, [period])

  const clearPeriod = () => {
    searchParams.delete('period')
    setSearchParams(searchParams)
    setPeriod({ month: null, year: null })
  }

  return (
    <Popover placement='bottom-end'>
      <PopoverHandler>
        <Button className='flex items-center gap-2' variant='outlined' color='white'>
          <FiCalendar size='1rem' />
          Periodo
        </Button>
      </PopoverHandler>
      <PopoverContent className='grid grid-cols-2 gap-4 w-[528px] z-50'>
        <div className='col-span-2'>
          <Typography variant='h6' className='text-black'>Período</Typography>
          <Typography variant='small' className='text-gray-600'>
            La selección de un período filtra sólo los indicadores y tablas de
            <span className='font-bold'>{' '}riesgo{' '}</span>y <span className='font-bold'>cumplimiento</span>
          </Typography>
        </div>
        <div className='flex flex-col'>
          <Typography className='text-sm'>Mes</Typography>
          <Select
            options={monthOptions}
            onChange={onChangePeriodMonth}
            menuPortalTarget={document.body}
            value={monthOptions.find(monthOption => monthOption.value === period.month) || null}
            placeholder='Seleccione'
            styles={{
              menuPortal: base => ({ ...base, zIndex: 100 })
            }}
          />
        </div>

        <div className='flex flex-col'>
          <Typography className='text-sm'>Año</Typography>
          <Select
            options={yearOptions()}
            value={yearOptions().find(yearOption => yearOption.value === period.year) || null}
            onChange={onChangePeriodYear}
            menuPortalTarget={document.body}
            placeholder='Seleccione'
            styles={{
              menuPortal: base => ({ ...base, zIndex: 100 })
            }}
          />
        </div>

        <Button
          type='button'
          color='red'
          variant='outlined'
          className='w-fit'
          size='sm'
          onClick={clearPeriod}
        >
          {t('filters.delete')}
        </Button>

      </PopoverContent>
    </Popover>
  )
}
